<div class="topbar">
    <div class="header-left">
        <div class="topnav">
            <a class="menutoggle" href="#" data-toggle="sidebar-collapsed"><span class="menu__handle"><span>Menu</span></span></a>
        </div>
    </div>
    <div class="header-right">
        <ul class="header-menu nav navbar-nav">
            <!-- BEGIN USER DROPDOWN -->
            <li class="dropdown" id="user-header">
                <a href="#" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
                    <span class="username">Bentornato, {{ user.username }}!</span>
                </a>
                <ul class="dropdown-menu">
                    <!-- <li><a [routerLink]="['/personal/profile']"><i class="icon-user"></i><span>Profilo</span></a></li> -->
                    <!-- <li><a [routerLink]="['/personal/settings']"><i class="icon-settings"></i><span>Impostazioni</span></a></li> -->
                    <li><a style="cursor: pointer;" (click)="signOut($event)"><i class="icon-logout"></i><span>Logout</span></a></li>
                </ul>
            </li>
            <!-- END USER DROPDOWN -->
        </ul>
    </div>
    <!-- header-right -->
</div>